<template lang="pug">
  el-dialog.quotation-detail(
    :visible="visible"
    :title="$t(viewMode ? '报价明细' : hasFilled ? '修改报价': '填写报价')"
    @close="closeDialog"
    width="900px"
    :close-on-click-modal="false"
    center
  )

    Tab(
      :tabs="tabs"
      :index="index"
      @change="onTabChange"
    )

    el-table(
      v-loading="loading"
      :data="tableData"
      :key="index"
      max-height="215"
    )
      el-table-column(
        prop="serviceId"
        align="left"
        :label="$t('服务类别')"
        min-width="160"
        :show-overflow-tooltip="viewMode"
        :render-header="renderHeader"
      )
        template(slot-scope="scope")
          span(style="float: left; color: #4896e6") {{ scope.$index + 1 }}.
          span(v-if="viewMode" style="margin-left: 3px") {{ isZh ? scope.row.serviceNameCh : scope.row.serviceName }}
          el-select(
            v-else
            v-model="scope.row.serviceId"
            :placeholder="$t('请选择类别')"
            size="mini"
            style="width: 110px; margin-left: 3px"
            @change="handleServiceChange(scope.row)"
            :disabled="checkShouldDisabled(scope.row.is_asset)"
          )
            el-option(
              v-for="o, i in serviceList"
              :key="i"
              :label="isZh ? o.service_name_ch : o.service_name"
              :value="o.service_id"
            )

      el-table-column(
        prop="serviceItemName"
        :label="$t('服务项目')"
        align="left"
        min-width="140"
        :show-overflow-tooltip="viewMode"
        :render-header="renderHeader"
      )
        template(slot-scope="scope")
          span(v-if="viewMode") {{ isZh ? scope.row.serviceItemNameCh : scope.row.serviceItemName }}
          template(v-else)
            el-select(
              v-if="getServiceItemList(scope.row.serviceId).length > 0  && !scope.row.isSelected3rdPartyCost"
              v-model="scope.row.serviceItemName"
              placeholder=""
              size="mini"
              @change="v => handleServiceItemSelect(getServiceItemList(scope.row.serviceId), scope.row)"
              :disabled="checkShouldDisabled(scope.row.is_asset)"
            )
              el-option(
                v-for="o, i in getServiceItemList(scope.row.serviceId)"
                :key="i"
                :label="isZh ? o.service_item_name_ch : o.service_item_name"
                :value="o.service_item_name"
                :disabled="tableData.map(t => t.serviceItemName).includes(o.service_item_name) || checkShouldDisabled(o.is_asset) || (!hasKolBuying && o.service_item_id === 1482)"
              )
            el-input(
              v-else
              v-model="scope.row.serviceItemName"
              :maxlength="100"
              :placeholder="$t('≤100字')"
              @change="v => handleServiceItemInput(v, scope.row)"
              :disabled="checkShouldDisabled(scope.row.is_asset)"
            )

      el-table-column(
        prop="unitPrice"
        :label="$t('单价')"
        align="left"
        min-width="150"
        :render-header="renderHeader"
      )
        template(slot-scope="scope")
          span(v-if="viewMode") {{ scope.row.unitPrice | formatMoney }}
          vue-numeric(
            v-else
            v-model="scope.row.unitPrice"
            :unit="$t('元')"
            :precision="2"
            :disabled="checkShouldDisabled(scope.row.is_asset) || !canEditUnitPrice(getServiceItemList(scope.row.serviceId), scope.row.serviceItemName)"
          )
      el-table-column(
        prop="number"
        :label="$t('数量')"
        align="left"
        min-width="100"
        :render-header="renderHeader"
      )
        template(slot-scope="scope")
          span(v-if="viewMode") {{ scope.row.number | numberWithCommas }}
          template(v-else)
            input-with-commas(
              v-model="scope.row.number"
              :disabled="checkShouldDisabled(scope.row.is_asset)"
            )
      el-table-column(
        width="150"
        :label="$t('总价')"
        align="left"
      )
        template(slot-scope="scope")
          span {{ getTotalPrice(scope.row) | formatMoney }}
      template(v-if="isIT")
        el-table-column(
          prop="solutionsName"
          :label="$t('可借助的其他现有UL解决方案')"
          align="left"
          width="280"
        )
          template(slot-scope="scope")
            span(v-if="viewMode") {{ scope.row.solutionsName ? scope.row.solutionsName : '—' }}
            el-input(
              v-else
              v-model="scope.row.solutionsName"
              :maxlength="100"
              :placeholder="$t('≤100字')"
              :disabled="checkShouldDisabled(scope.row.is_asset)"
            )
        el-table-column(
          prop="priceAfterLeveraging"
          :label="$t('借助其他解决方案后的报价')"
          align="left"
          width="220"
        )
          template(slot-scope="scope")
            span(v-if="viewMode") {{ scope.row.priceAfterLeveraging | formatMoney(2) }}
            input-with-commas(
              v-else
              v-model="scope.row.priceAfterLeveraging"
              :unit="$t('元')"
              @blur="(val) => {handlePriceAfterLeveragingBlur(val, scope.row)}"
            )
            //- vue-numeric(
            //-   v-else
            //-   v-model="scope.row.priceAfterLeveraging"
            //-   unit="元"
            //-   :precision="2"
            //-   :disabled="checkShouldDisabled(scope.row.is_asset)"
            //- )
        el-table-column(
          :label="$t('持续时间')"
          align="left"
          width="310"
        )
          template(slot-scope="scope")
            template(v-if="viewMode")
              span(v-if="!(scope.row.dateRange[0] && scope.row.dateRange[1])") —
              span(v-else) {{ scope.row.dateRange[0] | formatDate }} ~ {{ scope.row.dateRange[1] | formatDate }}
            div(
              v-else
            )
              el-date-picker(
                v-model="scope.row.dateRange[0]"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('开始日期')"
                style="width: 125px"
                :picker-options="startDatePickerOptions(scope.row)"
                :disabled="checkShouldDisabled(scope.row.is_asset)"
              )
              span(style="margin: 0 10px") {{ $t('至') }}
              el-date-picker(
                v-model="scope.row.dateRange[1]"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('结束日期')"
                style="width: 125px"
                :picker-options="endDatePickerOptions(scope.row)"
                :disabled="checkShouldDisabled(scope.row.is_asset)"
              )

      el-table-column(
        :label="$t('明细')"
        align="left"
        width="250"
        :style="{ display: 'flex', alignItems: 'center' }"
      )
        template(slot-scope="scope")
          span(v-if="viewMode && !scope.row.detail.name") —
          div(
            v-else
            :style="{ display: 'flex', alignItems: 'center' }"
          )
            template(v-if="viewMode")
              uploaded-file-display(
                :fileName="scope.row.detail.name"
                :downloadUrl="scope.row.detail.downloadPath"
                :fileNameList="scope.row.detail.nameList"
                width="120px"
              )
            template(v-else)
              template(v-if="scope.row.isSelectedKol")
                a(
                  :href="kolTemplateUrl"
                  target="_blank"
                )
                  el-button(style="margin-right: 10px") {{ $t('下载模板') }}
                el-upload(
                  accept=".xlsx,.xlsm"
                  :show-file-list="false"
                  :http-request="(file) => uploadTemplate(file, scope.row)"
                  action="组件必传，无意义"
                  :before-upload="onBeforeUpload"
                  style="display: inline-block; margin-right: 10px"
                )
                  el-button(
                    type="primary"
                    :disabled="checkShouldDisabled(scope.row.is_asset)"
                  ) {{ $t('点击上传') }}
              new-upload-file(
                v-else
                style="margin-right: 10px"
                axiosUrl="/management/subfinal/saveFile"
                :params="uploadParams"
                @loadingChange="status => loading = status"
                @uploadSuccess="res => uploadSuccess(res, scope.row)"
                :disabled="checkShouldDisabled(scope.row.is_asset)"
              )
              uploaded-file-display(
                :fileName="scope.row.detail.name"
                :downloadUrl="scope.row.detail.downloadPath"
                :fileNameList="scope.row.detail.nameList"
                :width="scope.row.isSelectedKol ? '60px' : '120px'"
              )
      el-table-column(
        :label="$t('备注')"
        align="left"
        width="150"
        :maxlength="100"
        :show-overflow-tooltip="viewMode"
      )
        template(slot-scope="scope")
          span(v-if="viewMode") {{ scope.row.remark || '—' }}
          el-input(
            v-else
            v-model="scope.row.remark"
            :maxlength="100"
            :placeholder="$t('≤100字')"
            :disabled="checkShouldDisabled(scope.row.is_asset)"
          )
      el-table-column(
        v-if="!viewMode"
        :label="$t('操作')"
        align="left"
      )
        template(slot-scope="scope")
          el-button(
            v-if="scope.$index !== 0"
            icon="el-icon-delete"
            circle
            style="margin-left: 5px"
            @click="delRow(scope)"
            :disabled="checkShouldDisabled(scope.row.is_asset)"
          )
          span(
            v-else
            style="margin-left: 10px"
          ) —

    el-button(
      v-if="!viewMode"
      type="text"
      style="margin: 0 10px 0"
      @click="addRow"
    ) + {{ $t('添加条目') }}
    el-button.export-kol-report__btn(
      @click="exportKolFailReport"
      v-if="KolFailReport != null"
    ) {{ $t('导出错误报告') }}
    .quotation-detail__summary
      div(
        v-if="!isDemoUser"
        style="color: #f66c62"
      )
        span(style="display: inline-block;") {{ $t('折扣') }}(-):
        span(
          v-if="viewMode"
          style="display: inline-block; width: 100px;"
        ) {{ currentData.discount | formatMoney }}
        template(v-else)
          input-with-commas(
            v-model="currentData.discount"
            :unit="$t('元')"
          )

      div(
        v-if="hasRebate"
        style="color: #f66c62; margin-top: 10px"
      )
        span(style="display: inline-block;") {{ $t('返点') }}:
        span(
          v-if="viewMode"
          style="display: inline-block; width: 100px;"
        ) {{ currentData.rebate | numberWithPercent }}
        template(v-else)
          el-input(
            style="width: 100px"
            v-model="currentData.rebate"
          )
            span(slot="suffix") %

      div(style="margin-top: 10px")
        span(style="display: inline-block") {{ $t('小计') }}:
        span(style="width: 100px;")
          span ￥
          span(style="font-size: 24px") {{ getTableTotalPrice() | numberWithCommas }}

    span(slot="footer")
      el-button(
        @click="handleConfirm"
        type="primary"
        :style="{ width: '140px' }"
      ) {{ $t('确定') }}
</template>

<script>
import UploadFile from '@/components/UploadFile'
import Tab from './Tab'
import axios from 'axios'
import { pickBy, flatten } from 'lodash'
import { numberWithPercent, formatMoney, numberWithCommas, format4backend, formatDate } from '@/umcc/util'
import dayjs from 'dayjs'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import InputWithCommas from '@/components/InputWithCommas'
import db from '@/umcc/db'
import accounting from 'accounting-js'
import VueNumeric from '@/components/VueNumeric'

export function normalizeQuotation (category) {
  const q = {}
  const today = dayjs().format('YYYY-MM-DD')
  // 默认每个category会有一个空的报价
  if (category.vendor_price.length === 0) category.vendor_price.push({})

  q.categoryName = category.category_name
  q.categoryNameCh = category.category_name_ch
  q.categoryId = category.category_id
  q.discount = category.discount || 0
  q.rebate = category.rebate * 100 || 0
  q.totalPrice = category.total || 0
  q.fileName = category.file_name
  q.tableData = category.vendor_price.map(item => ({
    serviceId: item.service_id,
    serviceItemId: item.service_item_id || '',
    serviceName: item.service_name,
    serviceItemName: item.service_item_name || '',
    serviceNameCh: item.service_name_ch,
    serviceItemNameCh: item.service_item_name_ch || '',
    unitPrice: item.unit_price || 0,
    number: item.number || 0,
    totalPrice: item.total_price || 0,
    detail: {
      name: item.file_name || '',
      downloadPath: item.download_url || '',
      serverPath: item.detail_path || '',
      nameList: item.file_name_list || []
    },
    remark: item.remark || '',
    priceAfterLeveraging: item.price_after_leveraging || '',
    solutionsName: item.solutions_name || '',
    dateRange: [item.coverage_start_date || today, item.coverage_end_date || today],
    is_asset: item.is_asset || 0
  }))

  return q
}

export function formatParams (subFinalScopeVendorId, quotation) {
  const serviceItem = flatten(quotation.map(item => item.tableData.map(o => ({ service_item_name: o.serviceItemName }))))
  let res = {}
  res.sub_final_scope_vendor_id = subFinalScopeVendorId
  res.service_item = serviceItem.map(i => [{ service_item_name: i.service_item_name }])
  res.vendor_offer_price = flatten(quotation.map(item => {
    return item.tableData.map(o => {
      const res = {
        category_id: item.categoryId,
        service_id: o.serviceId,
        unit_price: o.unitPrice,
        number: o.number,
        total_price: o.totalPrice,
        detail_path: o.detail.serverPath,
        remark: o.remark,
        solutions_name: o.solutionsName,
        price_after_leveraging: o.priceAfterLeveraging,
        coverage_start_date: o.dateRange[0],
        coverage_end_date: o.dateRange[1]
      }
      if (o.serviceItemId !== '' && o.serviceName !== 'Others' && o.serviceName !== '3rd party cost') {
        res.service_item_id = o.serviceItemId
      }
      return pickBy(res, v => { return v != null })
    })
  }))
  res.vendor_offer_discount = quotation.map(o => {
    return {
      category_id: o.categoryId,
      discount: o.discount,
      rebate: o.rebate / 100
    }
  })
  return res
}

const updatePreviewVendorQuotation = (params) =>
  axios.post('/management/subfinal/vendorPricePreview', format4backend(params))

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array
    },
    hasFilled: {
      type: Boolean,
      default: false
    },
    hasRebate: {
      type: Boolean,
      default: false
    },
    hasKol: {
      type: Boolean,
      default: true
    },
    checkIsAsset: {
      type: Boolean,
      default: false
    },
    hasSync: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      index: 0,
      loading: false,
      serviceList: [],
      kolTemplateUrl: null,
      hasKolBuying: true,
      KolFailReport: null
    }
  },
  computed: {
    currentData () {
      return this.data[this.index]
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    isIT () {
      return this.currentData.categoryName === 'IT'
    },
    tableData () {
      return this.currentData.tableData
    },
    uploadParams () {
      return {
        campaign_id: this.campaignId,
        file_type: 13
      }
    },
    isZh () {
      return db.lang === 'zh'
    },
    tabs () {
      if (this.isZh) return this.data.map(i => `${i.categoryNameCh}(${i.categoryName})`)
      return this.data.map(i => i.categoryName)
    },
    isDemoUser () {
      return this.$store.state.common.user.company_name === 'Mccann'
    }
  },
  mounted () {
    this.fetchServiceList(this.index)
    this.checkKolBuying()
    if (!this.viewMode && this.hasKol) {
      this.getKolTemplate()
    }
  },
  filters: {
    formatMoney,
    numberWithCommas,
    numberWithPercent,
    formatDate
  },
  methods: {
    handleBlur (val, row) {
      row.unitPrice = accounting.toFixed(row.unitPrice, 2)
    },
    handlePriceAfterLeveragingBlur (val, row) {
      row.priceAfterLeveraging = accounting.toFixed(row.priceAfterLeveraging, 2)
    },
    checkShouldDisabled (isAsset) {
      return this.hasSync && this.checkIsAsset && isAsset === 1
    },
    getKolTemplate () {
      axios.get('/management/subfinal/getKolTemplate', {
        params: {
          sub_final_scope_id: this.subFinalScopeId
        }
      })
        .then(res => {
          this.kolTemplateUrl = res.download_url
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    renderHeader (h, { column, $index }) {
      return <span class="required">
        { column.label }
      </span>
    },
    handleServiceChange (row) {
      // 重置项目及单价
      row.isSelected3rdPartyCost = false
      row.isSelectedKol = false
      row.unitPrice = 0
      row.serviceItemName = ''
    },
    canEditUnitPrice (list, name) {
      const item = list.find(item => item.service_item_name === name)
      return !(item && item.price)
    },
    getServiceItemList (id) {
      const list = this.serviceList.find(i => i.service_id === id)
      if (!list) return []
      return list.children
    },
    async fetchServiceList (i) {
      this.loading = true
      const res = await axios.get('/management/subfinal/getServiceList', {
        params: {
          category_id: this.data[i].categoryId
        }
      })
      const serviceItemList = await Promise.all(res.map(item => axios.get('/management/subfinal/getServiceItemList', {
        params: { service_id: item.service_id }
      })))
      this.serviceList = res.map((item, index) => {
        item.children = serviceItemList[index]
        return item
      })
      this.data[this.index].tableData.forEach((r, i) => {
        r.isSelected3rdPartyCost = r.serviceItemId === ''
        r.isSelectedKol = r.serviceItemName === 'KOL Buy'
        return r
      })
      this.loading = false
    },
    onTabChange (i) {
      this.index = i
      if (this.viewMode) return
      this.fetchServiceList(i)
    },
    delRow (scope) {
      this.tableData.splice(scope.$index, 1)
    },
    getTotalPrice (row) {
      row.totalPrice = row.unitPrice * row.number
      return row.totalPrice
    },
    addRow () {
      this.tableData.push({
        serviceId: null,
        serviceName: '',
        serviceItemName: '',
        serviceItemId: '',
        isSelected3rdPartyCost: false,
        isSelectedKol: false,
        unitPrice: 0,
        number: 0,
        totalPrice: 0,
        detail: {
          name: '',
          downloadPath: '',
          serverPath: '',
          nameList: []
        },
        remark: '',
        priceAfterLeveraging: '',
        solutionName: '',
        dateRange: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        is_asset: 0
      })
    },
    handleServiceItemSelect (list, row) {
      row.isSelectedKol = row.serviceItemName === 'KOL Buy'
      row.serviceItemId = list.find(o => o.service_item_name === row.serviceItemName).service_item_name === '3rd party cost' ? '' : list.find(o => o.service_item_name === row.serviceItemName).service_item_id
      row.isSelected3rdPartyCost = row.serviceItemId === ''
      if (row.serviceItemId === '') {
        row.serviceItemName = ''
      } else {
        row.unitPrice = list.find(o => o.service_item_name === row.serviceItemName).price || 0
      }
    },
    handleServiceItemInput (servive, row) {
      row.serviceItemId = ''
      row.unitPrice = 0
    },
    validateKol (kolPath) {
      return axios.get('/management/subfinal/getKolPreview', {
        params: {
          sub_final_scope_id: this.subFinalScopeId,
          kol_path: kolPath
        }
      })
    },
    async validator () {
      const res = []

      this.data.map(item => {
        const name = item.categoryName

        if (item.discount === '' || item.discount == null) item.discount = 0
        if (item.rebate === '' || item.rebate == null) item.rebate = 0

        if (item.totalPrice < 0) {
          res.push(name + '' + 'Total ' + this.$t('不能为负数'))
        }

        item.tableData.map(async o => {
          if (o.serviceItemName === '') {
            res.push(this.$t('请填写必填项'))
          }

          if (o.unitPrice < 1) {
            res.push(this.$t('请填写必填项'))
          }

          if (!Number.isInteger(o.number) || o.number < 1) {
            res.push(name + ' ' + this.$t('数量格式不正确'))
          }

          if (o.remark && o.remark.length > 100) {
            res.push(this.$t('备注超长，请修改至100个字符以内'))
          }

          if (o.priceAfterLeveraging !== '' && !/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(o.priceAfterLeveraging)) {
            res.push(name + '' + this.$t('借助其他解决方案后的报价应为正数且至多两位小数'))
          }

          if (o.serviceItemName === 'KOL Buy') {
            if (o.detail.serverPath === '') {
              res.push(this.$t('请上传KOL报价单'))
            }
          }
        })
      })

      if (res.length > 0) {
        this.$message.error(res[0])
        return false
      }

      return true
    },
    getTableTotalPrice () {
      const sum = this.tableData.reduce((sum, cur) => sum + cur.totalPrice, 0)
      this.currentData.totalPrice = (sum - this.currentData.discount) * ((100 - this.currentData.rebate) * 0.01)
      return this.currentData.totalPrice.toFixed(2)
    },
    async handleConfirm () {
      if (this.viewMode) {
        this.$emit('close')
        return
      }

      if (!await this.validator()) return

      this.loading = true

      // should be props
      const subFinalScopeVendorId = this.$store.state.campaign.subFinalScopeVendorId ||
        this.$store.state.campaign.subFinalScopeInfo.sub_final_scope_vendor_id
      const params = formatParams(subFinalScopeVendorId, this.data)
      try {
        const res = await updatePreviewVendorQuotation(params)
        this.$message.success(this.$t('保存成功'))
        this.loading = false
        this.$emit('close', res, params)
      } catch (err) {
        // this.$message.error(this.$t('保存失败'))
        this.loading = false
      }
    },
    uploadSuccess (res, row) {
      row.detail = {
        name: res.file_name,
        serverPath: res.file_path,
        downloadPath: res.file_download_path,
        nameList: res.file_name_list
      }
      this.loading = false
    },
    startDatePickerOptions (row) {
      return {
        disabledDate: (time) => {
          if (row.dateRange[1]) {
            return time.getTime() > dayjs(row.dateRange[1]).unix() * 1000
          }
          return false
        }
      }
    },
    endDatePickerOptions (row) {
      return {
        disabledDate: (time) => {
          if (row.dateRange[0]) {
            return time.getTime() < dayjs(row.dateRange[0]).unix() * 1000
          }
        }
      }
    },
    closeDialog () {
      this.$emit('close')
    },
    onBeforeUpload (file) {
      // const result = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel.sheet.macroenabled.12' || file.type === 'application/vnd.ms-excel.sheet.macroEnabled.12'
      const filePattern = /\.xls(x|m)$/
      const result = filePattern.test(file.name)
      if (!result) {
        this.$message.error('文件格式错误，请重新上传')
      }
      // 请上传不大于500K的图片
      return result
    },
    async uploadTemplate (file, row) {
      this.KolFailReport = null
      try {
        this.loading = true
        const formData = new window.FormData()
        formData.append('file', file.file)
        formData.append('file_type', 13)
        const res = await axios.post('/management/subfinal/saveFile', formData)
        const validRes = await this.validateKol(res.file_path)
        if (!validRes.status) {
          this.KolFailReport = await axios.get('/management/subfinal/exportKolFailReport', {
            params: {
              sub_final_scope_id: this.subFinalScopeId,
              kol_path: res.file_path
            }
          })
          this.loading = false
          return
        }
        row.detail = {
          name: res.file_name,
          serverPath: res.file_path,
          downloadPath: res.file_download_path,
          nameList: res.file_name_list
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    checkKolBuying () {
      axios.get('/management/subfinal/checkKolBuying', {
        params: {
          sub_final_scope_id: this.subFinalScopeId
        }
      })
        .then(res => {
          this.hasKolBuying = res.has_kol_buying
        })
    },
    exportKolFailReport () {
      window.open(this.KolFailReport.download_url, '_blank')
    }
  },
  components: {
    Tab,
    UploadMultipleFile,
    UploadFile,
    NewUploadFile,
    UploadedFileDisplay,
    InputWithCommas,
    VueNumeric
  }
}
</script>

<style lang="stylus">
$border = solid 1px #979797

.quotation-detail
  .export-kol-report__btn
    display block
    margin-left auto
    margin-right 55px
  .el-table
    padding 10px
    box-shadow 0 1px 10.5px 0 rgba(72, 150, 230, 0.12)
    &:before
      content none
  .el-dialog
    background #fafbfc
  .el-dialog__body
    padding 25px 25px 0px
    .tab
      margin-bottom 10px
  .el-dialog__header
    text-align left
  .el-dialog__footer
    padding-bottom 32px
  .el-range-editor--mini.el-input__inner
    width 210px

.quotation-detail__summary
  padding 10px 55px
  font-size $font-small
  > div
    display flex
    justify-content flex-end
    line-height 28px
    > span:first-child
      margin-right 10px
  .el-input
    width 100px
</style>
